export const applicationConstants = {
  ANTILOC_REQUEST: 'APPLICATION_ANTILOC_REQUEST',
  ANTILOC_SUCCESS: 'APPLICATION_ANTILOC_SUCCESS',
  ANTILOC_FAILURE: 'APPLICATION_ANTILOC_FAILURE',
};
